import { Component, inject } from "@angular/core";
import { UserService } from "src/app/services/user.service";

@Component({
    selector: "app-infoportal-api-navigation",
    templateUrl: "./infoportal-api-navigation.component.html",
    styleUrls: ["./infoportal-api-navigation.component.css"],
    standalone: false
})
export class InfoportalApiNavigationComponent {
  private _userService = inject(UserService);

  public navItems = [];
  constructor() {
    this.navItems = [{ text: $localize`:@@InfoportalAPI_NavHeader_Facilities:Facilities`, routerLink: "anlagen" }];
    if (this._userService.CurrentUser.internalAccess === true) {
      this.navItems.push({ text: $localize`:@@InfoportalAPI_NavHeader_Customers:Customers`, routerLink: "customers" });
    }
  }
}
